import { createTermTagManager } from '../../utils/createTermTagManager';

export const hasFlatTourBookingTagManager = createTermTagManager({
  jsonQueryKey: 'has_flat_tour_booking',
  label: 'С записью на просмотр',
  id: 'hasFlatTourBooking',
});
